import { render, staticRenderFns } from "./ScipInformationSection.vue?vue&type=template&id=e1142e68&"
import script from "./ScipInformationSection.vue?vue&type=script&lang=js&"
export * from "./ScipInformationSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports